import React, { Component } from 'react'
import { Accordion, Icon } from 'semantic-ui-react'

class Help extends Component {
    state = { activeIndex: 0 }
    handleClick = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index
    
        this.setState({ activeIndex: newIndex })
      }
      questions = [
        {display:"all", question:"Was ist korAccount Mobile?", answer:"Mit korAccount Mobile können Sie ganz einfach Ihre Ausgaben unterwegs erfassen und später in korAccount übertragen."},
        {display:"desktop", question:"Wie kann ich es nutzen?", answer:"Besuchen Sie mit ihrem Mobilgerät einfach https://kornelius.org/mobile und nutzen Sie es unterwegs."},
        {display:"all", question:"Gibt es auch eine App für iPhone oder Android?", answer:"korAccount Mobile können Sie einfach auf den Startbildschirm heften. Es funktioniert dann ganz wie eine App."},
        {display:"all", question:"Wo werden meine Daten gespeichert?", answer:"korAccount Mobile speichert alle Ihre Daten direkt im Browser. Ihre Eingaben werden also nicht an einen Server übermittelt oder gespeichert."},
        {display:"mobile", question:"Wie stabil ist korAccount Mobile?", answer:"Momentan ist es noch rudimentär. Sollte etwas nicht funktionieren, freue ich mich über Rückmeldungen."},
        {display:"mobile", question:"Funktioniert korAccount Mobile auch offline oder bei schlechter Verbindung?", answer:"Der Offlinemodus kommt hoffentlich bald."},
        //Nach dem ersten Laden funktioniert korAccount Mobile auch offline. Zum Übertragen müssen Sie natürlich online sein.
        {display:"mobile",question:"Wie werden meine Eingaben übermittelt?", answer:"Beim Übertragen der Daten in korAccount werden ihre Eingaben über einen Vermittlungsserver verschlüsselt (https) verschickt."},
        {display:"mobile",question:"Auf was muss ich achten?", answer:"Löschen Sie Ihren Browser-Cache idealerweise nicht. Ihre Eingaben können andernfalls verlohren gehen."},
        {display:"mobile",question:"Wie geht es weiter?", answer:"Verbessert soll das Layout werden. Dazu soll noch ein Offlinemodus kommen. Ansonsten bitte Feedback über kornelius.org/contact, was es noch braucht."},
    ]

    render()
    {
       const { activeIndex } = this.state
       const {IsDesktop}  = this.props
       const IsMobile  = !Boolean(IsDesktop)
        return (
            <div>
                <Accordion styled>
                { this.questions.filter(obj => obj.display=="all" || (obj.display=="mobile" && IsMobile==true) || (obj.display=="desktop" && {IsDesktop})).map((entry, index) => ( 
                <div key={index}>
                <Accordion.Title active={activeIndex === index} index={index} onClick={this.handleClick}>
                    <Icon name='dropdown' />{entry.question}
                </Accordion.Title>
                <Accordion.Content active={activeIndex === index}>
                    <p>{entry.answer}</p>
                </Accordion.Content>
                </div>
                ))} 
            </Accordion>
            </div>
        )
       
    }
}
export default Help